module.exports = __webpack_public_path__ + "src/assets/textures/env/corn_cards/cornstalk_card_alpha.png";